import axios from 'axios'
import {ClaimsParams, ClaimsResponse} from '../hooks/useClaims'

export const fetchClaims = async (
  params: ClaimsParams,
  currentUser: any
): Promise<ClaimsResponse> => {
  const {searchType, searchQuery, currentPage, pageSize, activeTab} = params

  let queryParam = ''
  if (searchQuery && searchQuery.trim() !== '') {
    switch (searchType) {
      case 'Claim Number':
        queryParam = `claimNumber=${searchQuery}`
        break
      case 'Nama Member':
        queryParam = `memberName=${searchQuery}`
        break
      case 'Card Number':
        queryParam = `cardNumber=${searchQuery}`
        break
      case 'Policy Number':
        queryParam = `policyNumber=${searchQuery}`
        break
      case 'Customer Group':
        queryParam = `customerGroup=${searchQuery}`
        break
      case 'Created Date':
        queryParam = `createdDate=${searchQuery}`
        break
      case 'Status':
        queryParam = `status=${searchQuery}`
        break
      default:
        queryParam = ''
    }
  }

  const apiUrl = `${process.env.REACT_APP_API_PROVIDER_URL}/api/Claims`

  const response = await axios.get(apiUrl, {
    params: {
      ProviderCode: currentUser?.providerCode,
      ...(activeTab === 'all' && {
        'Page.query': queryParam || undefined,
        SearchType: searchType,
        SearchQuery: searchQuery,
      }),
      'Page.page': currentPage,
      'Page.pageSize': pageSize,
    },
    headers: {
      Authorization: `Bearer ${currentUser?.token}`,
    },
    paramsSerializer: {
      indexes: null,
    },
  })

  return response.data
}

export const fetchMyTurnClaims = async (
  params: ClaimsParams,
  currentUser: any
): Promise<ClaimsResponse> => {
  const {currentPage, pageSize} = params

  const apiUrl = `${process.env.REACT_APP_API_PROVIDER_URL}/api/Claims/ProviderTask`

  const response = await axios.get(apiUrl, {
    params: {
      ProviderCode: currentUser?.providerCode,
      'Page.page': currentPage,
      'Page.pageSize': pageSize,
    },
    headers: {
      Authorization: `Bearer ${currentUser?.token}`,
    },
    paramsSerializer: {
      indexes: null,
    },
  })

  return response.data
}
